var render, staticRenderFns
import script from "./alert-message.vue?vue&type=script&lang=js"
export * from "./alert-message.vue?vue&type=script&lang=js"
import style0 from "./alert-message.vue?vue&type=style&index=0&id=5e34446a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports